const emptyArray = [];
const emptyObj = {};

export const getCompanyCommissionMembers = (state) =>
  state?.commission?.commission?.data || emptyObj;
